import axios from 'axios';
/** @typedef {import('../../pages/fulfillments/advanced-shipping-notices/constants').AdvancedShippingNotice} AdvancedShippingNotice */

/**
 * @param {number} sellerFillProviderId
 * @param {string} asnGuid
 * @param {AdvancedShippingNotice} advancedShippingNotice
 * @returns {Promise<string>}
 */
export const syncProducts = (sellerFillProviderId, asnGuid, advancedShippingNotice) => {
  const post = axios
    .post('/asns/startProductSync', {
      sellerFillProviderId,
      asnGuid,
      advancedShippingNotice,
    })
    .then((res) => res.data);

  return post;
};
